import { render, staticRenderFns } from "./ManagingRevenueScope.vue?vue&type=template&id=93d62bb2&scoped=true"
import script from "./ManagingRevenueScope.vue?vue&type=script&lang=js"
export * from "./ManagingRevenueScope.vue?vue&type=script&lang=js"
import style0 from "./ManagingRevenueScope.vue?vue&type=style&index=0&id=93d62bb2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d62bb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d62bb2')) {
      api.createRecord('93d62bb2', component.options)
    } else {
      api.reload('93d62bb2', component.options)
    }
    module.hot.accept("./ManagingRevenueScope.vue?vue&type=template&id=93d62bb2&scoped=true", function () {
      api.rerender('93d62bb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tutition_v3/ManagingRevenueScope.vue"
export default component.exports